/**
 * Poupée Gigogne Toogle
 */
(function ($) {

    var toogler_modules = $(".Poupee-gigogne-select[data-selector='modules'] .Poupee-gigogne-dropdown");
    var toogler_competences = $(".Poupee-gigogne-select[data-selector='competences'] .Poupee-gigogne-dropdown");

    "use strict";
    $(document).ready(function () {

        $(toogler_competences).click(function(){
            $("[data-reveal='competences']").toggle(100);
        });

        $(toogler_modules).click(function(){
            $("[data-reveal='modules']").toggle(100);
        });

    })
})
(jQuery);


